//
// React
//
import React from 'react';

// Create a hal forms context for the components bound to that components tree
const HalFormsPageContext = React.createContext(undefined);

export default HalFormsPageContext;
